import React from 'react';
import { List } from 'react-admin';

import { Card } from '@mui/material';

import AuditDatagrid from './AuditDatagrid';
import AuditFilter from './AuditFilter';

import Pagination from '../layout/Pagination';

const AuditList = () => (
  <List
    filters={<AuditFilter />}
    sort={{ field: 'date', order: 'DESC' }}
    empty={false}
    pagination={<Pagination disableEmptyText />}
    exporter={false}
  >
    <Card sx={{ margin: 0 }} variant="outlined">
      <AuditDatagrid />
    </Card>
  </List>
);

export default AuditList;
